//TE for Data Persistence using create slice method start
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assessments: {},
  rejectMitigation: {},
};

const capSelfAssessmentSlice = createSlice({
  name: "capSelfAssessment",
  initialState,
  reducers: {
    saveSelfAssessment: (state, action) => {
      const { assessmentId, subcontrolId, field, value } = action.payload;

      if (!state.assessments[assessmentId]) {
        state.assessments[assessmentId] = {};
      }

      if (!state.assessments[assessmentId].answers) {
        state.assessments[assessmentId].answers = {};
      }

      if (!state.assessments[assessmentId].answers[subcontrolId]) {
        state.assessments[assessmentId].answers[subcontrolId] = {};
      }

      state.assessments[assessmentId].answers[subcontrolId][field] = value;
    },

    clearSelfAssessment: (state, action) => {
      const assessmentId = action.payload;
      delete state.assessments[assessmentId];
    },

    saveMitigationSuggestion: (state, action) => {
      const { assessmentId, submissionId, value } = action.payload;

      if (!state.assessments[assessmentId]) {
        state.assessments[assessmentId] = {};
      }

      if (!state.assessments[assessmentId].mitigationSuggestions) {
        state.assessments[assessmentId].mitigationSuggestions = {};
      }

      state.assessments[assessmentId].mitigationSuggestions[submissionId] = value;
    },

    clearMitigationSuggestion: (state, action) => {
      const assessmentId = action.payload;

      if (state.assessments[assessmentId]) {
        state.assessments[assessmentId].mitigationSuggestions = {};
      }
    },

    saveRejectMitigation: (state, action) => {
      const { submissionID, value } = action.payload;
      state.rejectMitigation[submissionID] = value;
    },

    clearRejectMitigation: (state) => {
      state.rejectMitigation = {};
    },

    saveMitigationResponse: (state, action) => {
      const { assessmentId, submissionId, value } = action.payload;

      if (!state.assessments[assessmentId]) {
        state.assessments[assessmentId] = {};
      }

      if (!state.assessments[assessmentId].mitigationResponses) {
        state.assessments[assessmentId].mitigationResponses = {};
      }

      state.assessments[assessmentId].mitigationResponses[submissionId] = {
        actionTaken: value,
      };
    },

    clearMitigationResponse: (state, action) => {
      const assessmentId = action.payload;

      if (state.assessments[assessmentId]) {
        state.assessments[assessmentId].mitigationResponses = {};
      }
    },

    resetCapSelfAssessmentData: () => {
      return initialState;
    },

  },
});

export const {
  saveSelfAssessment,
  clearSelfAssessment,
  saveMitigationSuggestion,
  clearMitigationSuggestion,
  saveRejectMitigation,
  clearRejectMitigation,
  saveMitigationResponse,
  clearMitigationResponse,
  resetCapSelfAssessmentData,
} = capSelfAssessmentSlice.actions;

export default capSelfAssessmentSlice.reducer;
//TE for Data Persistence using create slice method end
